import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  TextField,
} from '@mui/material';
import { NoteFormDialogProps } from './types';

const NoteFormDialog = ({ open, onClose, onSave, note }: NoteFormDialogProps) => {
  const [content, setContent] = useState('');
  const [authorName, setAuthorName] = useState('Turn Team');
  const [visibleToPartner, setVisibleToPartner] = useState(true);

  const isEdit = !!note;

  useEffect(() => {
    if (note) {
      setContent(note.note);
      setAuthorName(note.author_name || '');
      setVisibleToPartner(note.visible_to_partner);
    } else {
      setContent('');
      setAuthorName('Turn Team');
      setVisibleToPartner(true);
    }
  }, [note, open]);

  const handleSave = () => {
    if (!content.trim()) return;

    onSave({
      note: content.trim(),
      author_name: authorName.trim(),
      visible_to_partner: visibleToPartner,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? 'Edit Note' : 'Add Note'}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Content"
            multiline
            minRows={3}
            maxRows={10}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            fullWidth
          />
          <TextField
            label="Author Name (optional)"
            value={authorName}
            onChange={(e) => setAuthorName(e.target.value)}
            fullWidth
          />
          <FormControlLabel
            control={<Switch checked={visibleToPartner} onChange={(e) => setVisibleToPartner(e.target.checked)} />}
            label="Visible to Partner"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={!content.trim()}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoteFormDialog;
